export class ServiceConstants {
    public static readonly API_URL = {
        MEMBER_CLAIM_SEARCH: "/claims-service/claims-service/rest/searchClaims"
    }
}

